/*
 * Made by Kyle
 *
 * order-ready-date.js
 *
 * Shows when a freshly-made order will be ready.
 * Rule: order day + 2 business days, where Sunday is the only non-working day.
 * "Today" is always read in the bakery's timezone (America/Los_Angeles), so the
 * estimate is correct no matter where the customer is browsing from.
 */
(function () {
  'use strict';

  var TIME_ZONE = 'America/Los_Angeles';
  var ROOT_SELECTOR = '[data-order-ready-date]';
  var VALUE_SELECTOR = '[data-order-ready-date-value]';
  var CART_ITEM_SELECTOR = '[data-js-cart-item]';

  // Current calendar date in the bakery's timezone, as a local date-only Date.
  function getBakeryToday() {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: TIME_ZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(new Date()).split('-');
    return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
  }

  // Add 2 business days; Sunday (0) is the only non-working day.
  function getReadyDate(startDate) {
    var result = new Date(startDate);
    var remaining = 2;
    while (remaining > 0) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0) remaining -= 1;
    }
    return result;
  }

  function formatReadyDate(date) {
    return new Intl.DateTimeFormat('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric'
    }).format(date);
  }

  function update() {
    var readyText = formatReadyDate(getReadyDate(getBakeryToday()));
    var cartHasItems = document.querySelector(CART_ITEM_SELECTOR) !== null;
    var roots = document.querySelectorAll(ROOT_SELECTOR);

    for (var i = 0; i < roots.length; i += 1) {
      var root = roots[i];
      var valueEl = root.querySelector(VALUE_SELECTOR);
      if (valueEl) valueEl.textContent = readyText;

      // In a cart context, only show the note while there are items.
      var gateOnCart = root.getAttribute('data-order-ready-date') === 'cart';
      if (gateOnCart && !cartHasItems) {
        root.setAttribute('hidden', '');
      } else {
        root.removeAttribute('hidden');
      }
    }
  }

  function init() {
    update();

    // The cart drawer is replaced wholesale by the theme's JS when an item is
    // added or changed, and the new markup comes back with the note hidden and
    // empty. We watch for it being re-inserted and re-populate it — this is
    // mechanism-agnostic, so it works no matter which events the theme fires.
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j += 1) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches(ROOT_SELECTOR) || node.querySelector(ROOT_SELECTOR)) {
            update();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();